import Loading from '../../components/Loading';
import LoadMoreComponent from '../../components/LoadMoreComponent';
import query, { getArticleIdPlace, saveArticleIdPlace } from './query';
import CheckData from '../../components/CatchError';
import DataTable from '../../components/Datatable';
import { COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../helpers/table';
import Actions from './actions';

class ArticleIdPerformance extends LoadMoreComponent {
    constructor(props) {
        super();
        this.url = new URL(window.location);
        this.entity = this.url.searchParams.get('entities:in');

        this.loadMore = this.loadMore.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.offsetStep = 1000;
    }

    async componentDidMount() {
        try {
            const res = await getArticleIdPlace(this.props.domain_id);
            const data = await res.json();

            if (data.article_id_position) {
                this.setState({ id_place: data.article_id_position });

                this.query = query({ offset: 0, id_place: data.article_id_position });
                this.query.bind(this.setState.bind(this));
                this.query.update();
            } else {
                this.setState({ loading: false });
            }
        } catch (err) {
            console.log(err);
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            if (item.title) return item.title?.toLowerCase().includes(search.toLowerCase());
            return item.page?.toLowerCase().includes(search.toLowerCase());
        });
    }

    async onSubmit(e, value) {
        try {
            e.preventDefault();
            if (!value) return;
            this.query = query({ id_place: value, offset: 0 });
            this.query.bind(this.setState.bind(this));
            this.query.update();
            this.setState({ allData: [], id_place: value });
            await saveArticleIdPlace(this.props.domain_id, value);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        // if we get less than offsetStep it means we don't have more data
        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const attr = {
            query,
            offsetStep: this.offsetStep,
            id_place: this.state.id_place || this.props.id_place || 0,
        };

        if (this.state.loading && !this.state.loadMore) {
            return <Loading padding={20} />;
        }

        const hasPosition = !!this.state.id_place;

        const actions = (
            <Actions
                onSubmit={this.onSubmit}
                defaultValue={this.state.id_place}
                customNumber={this.state.id_place || 0}
                additionalClassname="withoutMargin"
            />
        );

        // When a position is set, show the compact button in the table header.
        // Otherwise the call-to-action renders as a full-width banner below the header.
        const extraHeaders = hasPosition ? (
            <div className="table-header-extra-btn">{actions}</div>
        ) : null;
        const banner = hasPosition ? null : actions;

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.state.allData}
                    loading={this.state.loading}
                    loadMore={this.state.loadMore}
                >
                    <DataTable
                        nodes={this.state.allData}
                        header="Article ID Performance"
                        sortFns={getSortKeys(COLUMNS())}
                        COLUMNS={COLUMNS(this.props.default_image)}
                        fileName="Article ID Performance"
                        forceRun={this.forceRun}
                        extraHeaders={extraHeaders}
                        banner={banner}
                        searchFunction={this.searchFunction}
                        defaultSortKey="clicks"
                        pdfColumnSize={18}
                        showLoadMoreBtn={showLoadMoreBtn}
                        loadMoreLoading={this.state.loadMore}
                        loadMore={() => this.loadMore(attr)}
                        customEmptyMessage={
                            this.state.id_place
                                ? 'No data found for the selected Article ID Place.'
                                : 'Please enter an Article ID Place to see performance data.'
                        }
                        showViewAll={this.state.allData?.length !== 0}
                        additionalStyles={setAdditionalStyles(COLUMNS(this.props.default_image))}
                    />
                </CheckData>
            </>
        );
    }
}
export default ArticleIdPerformance;
